import React, { useEffect, useState } from "react";
import "./TabTitles.scss";

export default function TabTitles({ onChange, style }) {
  const [currentKey, setCurrentKey] = useState("0");

  useEffect(() => {
    onChange(currentKey);
  }, [onChange, currentKey]);

  return (
    <div className="TabTitles" style={style}>
      <div
        className={currentKey === "0" ? "active" : null}
        onClick={() => setCurrentKey("0")}
      >
        그래프 보기
      </div>
      <div
        className={currentKey === "1" ? "active" : null}
        onClick={() => setCurrentKey("1")}
      >
        테이블 보기
      </div>
    </div>
  );
}
